import "./cfibre.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Cfibre() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731589956/cfibre3_xmly9k.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731589956/cfibre1_qnjkiw.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731589956/cfibre2_gaqcvg.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731589956/cfibre2_gaqcvg.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>Ceramic Fibre || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="Ceramic fiber is a highly heat-resistant material commonly used in industrial, commercial, and residential applications where insulation from high temperatures is essential. "/>
        <meta name="keywords" content="ceramic fibre, rockwool, glasswool, kaowool, Lagos Nigeria" />
        </Helmet>
        <h3>Ceramic Fibre</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Key Characteristics of Our  Ceramic Fibre:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Can withstand up to  1,260°C. 
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Light Weight & Low Thermal Conductivity
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Thermal Shock Resistance
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Chemical Stability
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Ceramic fiber is a highly heat-resistant material commonly used in industrial, commercial, and residential applications where insulation from high temperatures is essential. Made from alumina and silica, ceramic fibers can endure extreme temperatures, making them ideal for use in furnaces, kilns, foundries, and other high-temperature environments. It comes in various forms like blankets, boards, papers, and modules, providing flexibility in application.
        </div>
    </div>
  )
}
